import { getFileExtensionFromURL } from '../../media-manager-sdk/items';

const FONTS_EXTENSIONS = ['ttf', 'woff2', 'woff', 'otf'];

export const isFont = (fileName: string) => fileName && FONTS_EXTENSIONS.includes(getFileExtensionFromURL(fileName));
